/**
 * Temporary adoption notice shown on the policy Settings tab, directly under the Policy Term
 * section. The billing details section moved to the Payment & Price tab in PR #32896 (#32450);
 * this callout points staff to the new location instead of an Appcues tooltip.
 *
 * This is intentionally throwaway — remove it (and its usage in policy-settings.jsx) once staff
 * are acclimated to the move, in a few weeks.
 */
import React from 'react';
import PropTypes from 'prop-types';

import { Label } from 'core/components/label';
import infoIconWhite from 'core/assets/svg/ic-info-white.svg';

import useStyles from './billing-details-moved-callout.styles';

const BillingDetailsMovedCallout = ({ goToPaymentTab }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img src={infoIconWhite} className={classes.icon} alt="" />
      <Label type="whiteSmall" className={classes.note}>
        <span className={classes.bold}>Looking for the billing details?</span> They&rsquo;ve moved to the{' '}
        <button type="button" className={classes.link} onClick={goToPaymentTab}>
          Payment &amp; Price
        </button>{' '}
        tab.
      </Label>
    </div>
  );
};

BillingDetailsMovedCallout.propTypes = {
  goToPaymentTab: PropTypes.func.isRequired
};

export default BillingDetailsMovedCallout;
